import { getParentByClass } from "../../../resources/js/helper/helper";
import Swiper from "swiper";

(function () {
  // Classes
  const tabFilterClass = '.filter-single-application-tile';
  const tabClass = '.single-application-tile';

  const mbApplicationFilterslider = document.querySelectorAll(".application-filter-slider");
    let applicationFilterSwiper = [];

    for (let i = 0; i < mbApplicationFilterslider.length; i++) {
        applicationFilterSwiper[i] = new Swiper(mbApplicationFilterslider[i], {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 25,
        freeMode: true,
        });
    }

  /**
   * Setup Filters
   */
  function setupFilters() {
    const filters = document.querySelectorAll(tabFilterClass);

    // For each Accordion-component
    for (let c = 0; c < filters.length; c++) {
      filters[c].addEventListener("click", function (event) {
        onClickFilter(event.target);

        const tabsContainer = getParentByClass(event.target, 'com-application-tiles');

        const currentFilters = tabsContainer.querySelectorAll(tabFilterClass);

        for (let d = 0; d < currentFilters.length; d++) {
          currentFilters[d].classList.remove('active');
        }

        event.target.classList.add('active');
      });
    }
  }

  /**
   * Function to toggle clicked tab and deactivate the other
   */
  function onClickFilter(clickedFilter, filters) {
    const tabsContainer = getParentByClass(clickedFilter, 'com-application-tiles');

    const tabs = tabsContainer.querySelectorAll(
        tabClass
    );

    for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].id == clickedFilter.dataset.target) {
            tabs[i].classList.add('active');
        } else {
            tabs[i].classList.remove('active'); 
        }
    }
  }

  setupFilters();
})();
